import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { currentFlowTypeEnum } from '../../common/components/constants';
import Invoices from './Invoices';
import { getCompanyInvoicesInitiate } from '../../../actions/company';

const mapStateToProps = state => {
  const invoiceData = _get(state, 'company.invoiceData', []);
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  const tdsDetails = _get(state, 'company.meta_data.tds_details', {});
  return {
    currentFlow,
    viewOnlyMode,
    invoiceData,
    fetchingInvoices:
      _get(state, 'apiState.GET_COMPANY_INVOICES.isFetching', true) &&
      !_get(state, 'apiState.GET_COMPANY_INVOICES.isIdle', false),
    fetchedInvoices: _get(state, 'apiState.GET_COMPANY_INVOICES.success', true),
    tdsDetails,
  };
};

const mapDispatchToProps = dispatch => ({
  getCompanyInvoices: payload => dispatch(getCompanyInvoicesInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Invoices);
